import { Injectable } from '@angular/core';
import { RequestService } from './request.service';

export enum ApplicationConfigType{
    PlantingSiteListPageSize,
    CustomerListPageSize,
    ShowPlantTreesButton,
    PlantTreesURL,
    UserListPageSize,
    TreeSpecieListPageSize
}

export class ApplicationConfigModel{
    type: ApplicationConfigType;
    value: string;
    name: string;
}

@Injectable({
    providedIn: 'root'
})
export class ApplicationConfigService {

    public plantingSiteListPageSize: number = 25;
    public customerListPageSize: number =  25;
    public userListPageSize: number =  25;
    public treeSpecieListPageSize: number = 25;
    public plantTreesURL: string;
    public showPlantTreesButton: boolean;

    constructor(private request: RequestService) {
    }

    async getAppConfigs(): Promise<any> {
        let result = await this.request.getApi<ApplicationConfigModel[]>('applicationConfiguraion');
        this.setValues(result.data);
        return {
            plantingSiteListPageSize: this.plantingSiteListPageSize,
            customerListPageSize: this.customerListPageSize,
            userListPageSize: this.userListPageSize,
            treeSpecieListPageSize: this.treeSpecieListPageSize,
            showPlantTreesButton: this.showPlantTreesButton,
            plantTreesURL: this.plantTreesURL
        };
    }

    async updatePlantingSitePageSize(pageSize: number): Promise<void> {
        await this.request.patch('applicationConfiguraion/update-planting-site-page-size', { pageSize: +pageSize });
    }

    async updateCustomerPageSize(pageSize: number): Promise<void> {
        await this.request.patch('applicationConfiguraion/update-customer-page-size', { pageSize: +pageSize });
    }

    async updateUserPageSize(pageSize: number): Promise<void> {
        await this.request.patch('applicationConfiguraion/update-user-page-size', { pageSize: +pageSize });
    }

    async updateSpeciePageSize(pageSize: number): Promise<void> {
        await this.request.patch('applicationConfiguraion/update-tree-specie-page-size', { pageSize: +pageSize });
    }

    private setValues(applicationConfiguraion: ApplicationConfigModel[]){
        applicationConfiguraion.forEach(c => {
            if(c.type == ApplicationConfigType.PlantingSiteListPageSize)
                this.plantingSiteListPageSize = +c.value;

            if(c.type == ApplicationConfigType.CustomerListPageSize)
                this.customerListPageSize = +c.value;

            if(c.type == ApplicationConfigType.PlantTreesURL)
                this.plantTreesURL = c.value;

            if(c.type == ApplicationConfigType.ShowPlantTreesButton){
                this.showPlantTreesButton = !!this.plantTreesURL && (c.value.toLowerCase() == 'true');
            }

            if(c.type == ApplicationConfigType.TreeSpecieListPageSize)
            {
                this.treeSpecieListPageSize = +c.value;
            }
        });
    }
}
